"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("api");
var usageTracker_1 = require("../libzl/usageTracker");
var ZLTagger = /** @class */ (function () {
    function ZLTagger(locale, flow, buildId, modelType, modelName, platformId, packageId, packageName, modelSku, modelYear, summary) {
        var _this = this;
        this.updateModelInfo = function (modelSku, packageName) {
            _this.modelSku = modelSku;
            _this.UC10_packageswitch(_this.packageName, packageName);
            _this.packageName = packageName;
        };
        this.updateEnvironment = function (environment) {
            if (_this.environment.length > 0 && _this.environment !== environment) {
                _this.UC08_background(environment);
            }
            _this.environment = environment;
        };
        this.updateBuild = function (buildSession, summary) {
            if (summary) {
                if (summary.action === api_1.Action.ChangedFeature) {
                    window.zltagger.UC09_changeoptions(buildSession, summary);
                }
                else if (summary.action === api_1.Action.AddedAccessory && summary.item) {
                    window.zltagger.UC08_addaccessory(buildSession, summary.item);
                }
                else if (summary.action === api_1.Action.RemovedAccessory && summary.item) {
                    window.zltagger.UCXX_removeaccessory(buildSession, summary.item);
                }
                if (summary.resolution) {
                    for (var _i = 0, _a = summary.resolution.add; _i < _a.length; _i++) {
                        var item = _a[_i];
                        if (item.deselectable) {
                            window.zltagger.UC08_addaccessory(buildSession, item);
                        }
                    }
                    for (var _b = 0, _c = summary.resolution.remove; _b < _c.length; _b++) {
                        var item = _c[_b];
                        if (item.deselectable) {
                            window.zltagger.UCXX_removeaccessory(buildSession, item);
                        }
                    }
                }
            }
        };
        this.getStandardBYOBlock = function () {
            var byo = {
                version: "new",
                buildID: _this.buildId,
                flow: _this.flow,
            };
            if (window.zlbolt) {
                byo.zlboltid = window.zlbolt.identifier;
                byo.streaming = window.zlbolt.getCurrentMode() === "3D" ? "streaming" : "fixe image";
            }
            if (_this.environment.length > 0) {
                byo.background = _this.environment;
            }
            return byo;
        };
        this.pushtag = function (data, noByoModel) {
            if (data.event === undefined) {
                data.event = "byoAction";
            }
            if (data.byo === undefined) {
                data.byo = _this.getStandardBYOBlock();
            }
            if (data.sessionStats === undefined) {
                try {
                    data.sessionStats = usageTracker_1.getUsageStats();
                }
                catch (e) {
                    console.exception("Failed to get session stats" + e);
                }
            }
            var byoModelDefaults = {
                modelType: _this.modelType,
                modelName: _this.modelName,
                modelSku: _this.modelSku,
                packageName: _this.packageName
            };
            if (noByoModel === undefined || noByoModel === false) {
                if (data.byoModel === undefined) {
                    data.byoModel = byoModelDefaults;
                }
                else {
                    // if there's already byoModel data, just keep it as is and drop the defaults in too.
                    data.byoModel = __assign(__assign({}, byoModelDefaults), data.byoModel);
                }
            }
            if (_this.verbose) {
                console.log("Proposed tag: ", data);
            }
            if (window && window.parent) {
                // this is the exit point - pass it over to nextgen site for them to do the dataLayer.push call
                window.parent.postMessage(JSON.stringify({ event: "byo_datapush", params: data }), "*");
            }
            return true;
        };
        this.getModelPackageLabel = function () {
            // in spec as <model>_<package>
            return _this.platformId + "__" + _this.packageId; // todo?
        };
        // not sure the private keyword does anything here except indicate that I don't expect this to be called externally
        this.UC01_firstload = function (locale) {
            var splitLocale = locale.indexOf("-") >= 0 ? locale.split("-") : locale.split("_");
            _this.pushtag({
                event: "PV",
                page: {
                    "hostname": window.location.host,
                    "path": window.location.pathname + window.location.search,
                    "pathEN": window.location.pathname + window.location.search,
                    "country": splitLocale[1].toLowerCase(),
                    "language": splitLocale[0].toLowerCase(),
                    "siteVersion": "nextgen",
                    "versionRelease": "1.0.0" // todo
                },
                "virtual": {
                    "name": "byo",
                    "step": "custom-build"
                },
                "interaction": {
                    "category": "byo start",
                    "action": _this.flow,
                    "label": _this.getModelPackageLabel()
                }
            });
            ZLTagger.cloudmine(["BYOStart"], { platform: _this.platformId, package: _this.packageId, modelYear: _this.modelYear, initial: ZLTagger.processSummaryData(_this.initialDetails) });
        };
        this.UC08_background = function (environment) {
            ZLTagger.cloudmine(["BYOChangeEnvironment", environment]);
            _this.pushtag({
                interaction: {
                    category: "byo options",
                    action: "background selection",
                    label: environment
                }
            });
        };
        this.UC08_addaccessory = function (buildSession, accessory) {
            var _a, _b, _c;
            var pricing = buildSession.getPricingInfo();
            var data = {
                currency: pricing === null || pricing === void 0 ? void 0 : pricing.currency,
                current: pricing === null || pricing === void 0 ? void 0 : pricing.totalValue,
                sku: accessory.id,
                name: accessory.analyticsName
            };
            ZLTagger.cloudmine(["BYOCustomise", "AddAccessory", _this.platformId + " - " + _this.packageId + " - " + _this.modelYear], data, { Component: accessory.analyticsName, ComponentId: accessory.id });
            _this.pushtag({
                interaction: {
                    category: "byo customize",
                    action: "add accessory",
                    label: (_a = accessory.analyticsName) === null || _a === void 0 ? void 0 : _a.toLowerCase()
                },
                byoAccessory: {
                    accessoryName: (_b = accessory.analyticsName) === null || _b === void 0 ? void 0 : _b.toLowerCase(),
                    accessoryColor: "",
                    accessoryCategory: (_c = accessory.categoryId) === null || _c === void 0 ? void 0 : _c.toLowerCase(),
                    accessoryPrice: accessory.price
                }
            });
        };
        this.UCXX_removeaccessory = function (buildSession, accessory) {
            var pricing = buildSession.getPricingInfo();
            var data = {
                currency: pricing === null || pricing === void 0 ? void 0 : pricing.currency,
                current: pricing === null || pricing === void 0 ? void 0 : pricing.totalValue,
                sku: accessory.id,
                name: accessory.analyticsName
            };
            ZLTagger.cloudmine(["BYOCustomise", "RemoveAccessory", _this.platformId + " - " + _this.packageId + " - " + _this.modelYear], data, { Component: accessory.analyticsName, ComponentId: accessory.id });
        };
        this.UC09_changeoptions = function (buildSession, summary) {
            var _a, _b, _c, _d, _e, _f;
            var pricing = buildSession.getPricingInfo();
            var data = {
                currency: pricing === null || pricing === void 0 ? void 0 : pricing.currency,
                current: pricing === null || pricing === void 0 ? void 0 : pricing.totalValue,
                sku: (_a = summary.item) === null || _a === void 0 ? void 0 : _a.id,
                name: (_b = summary.item) === null || _b === void 0 ? void 0 : _b.analyticsName
            };
            ZLTagger.cloudmine(["BYOCustomise", "ChangeFeature", _this.platformId + " - " + _this.packageId + " - " + _this.modelYear], data, { Feature: (_c = summary.item) === null || _c === void 0 ? void 0 : _c.analyticsName, FeatureId: (_d = summary.item) === null || _d === void 0 ? void 0 : _d.id });
            _this.pushtag({
                interaction: {
                    category: "byo customize",
                    action: "change - " + ((_e = summary.item) === null || _e === void 0 ? void 0 : _e.categoryId),
                    label: (_f = summary.item) === null || _f === void 0 ? void 0 : _f.analyticsName
                }
            });
        };
        this.UC10_packageswitch = function (prevName, nextName) {
            if (prevName && prevName !== nextName) {
                _this.pushtag({
                    interaction: {
                        category: "byo package switch",
                        action: nextName,
                        label: "from " + prevName
                    }
                });
            }
        };
        this.UCXX_streamdowngraded = function (dueToPerformance) {
            if (dueToPerformance) {
                ZLTagger.cloudmine(["BYODowngradedDueToPerformance"]);
            }
            else {
                _this.pushtag({
                    event: "userAction",
                    interaction: {
                        category: "byo streaming",
                        action: "3d to 2d",
                        label: _this.modelName + "_" + _this.packageName
                    }
                });
            }
        };
        this.UCXX_cameramoved = function () {
            //ZLTagger.cloudmine(["BYOCameraMoved"]) Already tracked internally to LibZL
            var _a;
            _this.pushtag({
                event: "userAction",
                interaction: {
                    category: "byo options",
                    action: "rotate view - " + (((_a = window.zlbolt) === null || _a === void 0 ? void 0 : _a.getCurrentMode().toLowerCase()) || ""),
                    label: _this.modelName + "_" + _this.packageName
                }
            });
        };
        this.flow = flow;
        this.modelName = modelName;
        this.modelType = modelType;
        this.platformId = platformId;
        this.packageId = packageId;
        this.packageName = packageName;
        this.modelSku = modelSku;
        this.modelYear = modelYear;
        this.buildId = buildId;
        this.environment = "";
        this.initialDetails = summary;
        this.verbose = window.location.host.indexOf(":") > 0 || window.location.hostname.indexOf("-dev") > 0 || window.zlurlparams.debug;
        this.UC01_firstload(locale);
    }
    ZLTagger.push = function (data, noByoModel) {
        if (window.zltagger !== undefined) {
            return window.zltagger.pushtag(data, noByoModel);
        }
        else {
            console.log("Attempting to push tags before initializing tagger");
        }
        return false;
    };
    ZLTagger.cloudmine = function (type, data, kwargs) {
        var _a, _b, _c, _d;
        data = data || {};
        data.currentmode = (_a = window.zlbolt) === null || _a === void 0 ? void 0 : _a.getCurrentMode();
        data.usagehistory = usageTracker_1.getUsageStats();
        data.buildid = (_b = window.zltagger) === null || _b === void 0 ? void 0 : _b.buildId;
        console.log("CloudMine: " + type.join("."), type, data);
        (_d = (_c = window.zlbolt) === null || _c === void 0 ? void 0 : _c.cloudmine) === null || _d === void 0 ? void 0 : _d.event(__assign({ type: type, data: data }, (kwargs || {})));
    };
    /* possible "summary paths":
        1. send to dealer
        2. save + quote
        3. change model + quote
        4. calculator + apply for credit
        5. summary + apply for credit
        6. close + quote
        7. save
    */
    ZLTagger.processSummaryData = function (summary) {
        var _a, _b, _c;
        var accessoryItems = summary === null || summary === void 0 ? void 0 : summary.accessories.groups.reduce(function (p, g) { return __spreadArrays(p, g.items); }, []);
        return {
            sku: summary.package.id,
            includedAccessories: accessoryItems.filter(function (a) { return a === null || a === void 0 ? void 0 : a.locked; }).reduce(function (p, a) { return __spreadArrays(p, Array(a.locked).fill(a.id)); }, []),
            addedAccessories: accessoryItems.filter(function (a) { return ((a === null || a === void 0 ? void 0 : a.selected) || 0) > ((a === null || a === void 0 ? void 0 : a.locked) || 0); }).reduce(function (p, a) { return __spreadArrays(p, Array(((a === null || a === void 0 ? void 0 : a.selected) || 0) - ((a === null || a === void 0 ? void 0 : a.locked) || 0)).fill(a.id)); }, []),
            basePrice: (_a = summary.package.rawprice) === null || _a === void 0 ? void 0 : _a.amount,
            accessoriesPrice: (_b = summary.accessories.rawsubtotal) === null || _b === void 0 ? void 0 : _b.amount,
            totalPrice: (_c = summary.rawtotalprice) === null || _c === void 0 ? void 0 : _c.amount,
        };
    };
    ZLTagger.UC02_categorytool = function (action, label) {
        var _a, _b, _c;
        ZLTagger.cloudmine(["BYOCustomise", "OpenCategory", ((_a = window.zltagger) === null || _a === void 0 ? void 0 : _a.platformId) + " - " + ((_b = window.zltagger) === null || _b === void 0 ? void 0 : _b.packageId) + " - " + ((_c = window.zltagger) === null || _c === void 0 ? void 0 : _c.modelYear)], {}, { Category: label });
        return ZLTagger.push({
            "interaction": {
                "category": "byo customize",
                action: "open category - " + action,
                label: label
            }
        });
    };
    ZLTagger.UC03_options = function (action) {
        ZLTagger.cloudmine(["BYOClick", action]);
        return ZLTagger.push({
            "interaction": {
                "category": "byo options",
                action: action
            }
        });
    };
    ZLTagger.UC04_changepackage = function () {
        ZLTagger.cloudmine(["BYOCustomise", "ChangePackage"]);
        return ZLTagger.push({
            "interaction": {
                "category": "byo customize",
                "action": "change package"
            }
        });
    };
    ZLTagger.UC05_summary = function () {
        ZLTagger.cloudmine(["BYOViewSummary"]);
        return ZLTagger.push({
            "interaction": {
                "category": "byo review",
                "action": "view summary"
            }
        });
    };
    ZLTagger.UC06_save = function () {
        ZLTagger.cloudmine(["BYOSave"]);
        return ZLTagger.push({
            "interaction": {
                "category": "byo review",
                "action": "save"
            }
        });
    };
    ZLTagger.UC07_finished = function (summary, summaryPath) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var data = {
            currency: (_a = summary === null || summary === void 0 ? void 0 : summary.rawtotalprice) === null || _a === void 0 ? void 0 : _a.currency,
            initial: ((_b = window.zltagger) === null || _b === void 0 ? void 0 : _b.initialDetails) ? ZLTagger.processSummaryData(window.zltagger.initialDetails) : undefined,
            final: summary ? ZLTagger.processSummaryData(summary) : undefined
        };
        switch (summaryPath) {
            case "save + quote":
                ZLTagger.cloudmine(["BYOSaveQuote"], data);
                break;
            case "close + quote":
                ZLTagger.cloudmine(["BYOCloseQuote"], data);
                break;
            case "change model + quote":
                ZLTagger.cloudmine(["BYOChangeModel", "Quote"], data);
                break;
            case "calculator + apply for credit":
                ZLTagger.cloudmine(["BYOCalculator", "Credit"], data);
                break;
            case "send to dealer":
                var action = "brp_get_quote";
                if (process.env.REACT_APP_FINISHED_ACTION) {
                    if (process.env.REACT_APP_FINISHED_ACTION.includes("=")) {
                        var countryActions = process.env.REACT_APP_FINISHED_ACTION.split(",").map(function (p) { return p.split("="); }).filter(function (c) { return c[0] && c[1]; }).reduce(function (p, c) {
                            var _a;
                            return (__assign(__assign({}, p), (_a = {}, _a[c[0]] = c[1], _a)));
                        }, {});
                        action = countryActions[window.zlurlparams.locale.substr(2, 2)] || action;
                    }
                    else {
                        action = process.env.REACT_APP_FINISHED_ACTION;
                    }
                }
                if (action === "brp_pre_order" && !window.zlurlparams.alternateView) {
                    ZLTagger.cloudmine(["BYOPreorder"], data);
                }
                else {
                    ZLTagger.cloudmine(["BYOSendToDealer"], data);
                }
                break;
            case "preorder":
                ZLTagger.cloudmine(["BYOPreorder"], data);
                break;
            case "promotion":
                ZLTagger.cloudmine(["BYOPromotion"], data);
                break;
            case "summary + apply for credit":
                ZLTagger.cloudmine(["BYOSummary", "Credit"], data);
                break;
        }
        if (summary) {
            //console.log(fullSummary);
            var numAcc = ((_c = data.final) === null || _c === void 0 ? void 0 : _c.addedAccessories.length) || 0;
            var finishEvent = {
                interaction: {
                    category: "byo product summary",
                    action: ((_d = window.zltagger) === null || _d === void 0 ? void 0 : _d.getModelPackageLabel()) || "",
                    label: (_e = summary.rawtotalprice) === null || _e === void 0 ? void 0 : _e.amount.toString()
                },
                byoModel: {
                    modelColor: (_h = (_g = (_f = summary.options.find(function (o) { return o.id === "BRP_COLOR"; })) === null || _f === void 0 ? void 0 : _f.items[0]) === null || _g === void 0 ? void 0 : _g.analyticsName) === null || _h === void 0 ? void 0 : _h.toLowerCase(),
                    modelEngine: (_l = (_k = (_j = summary.options.find(function (o) { return /BRP_.+_ENGINE/.test(o.id); })) === null || _j === void 0 ? void 0 : _j.items[0]) === null || _k === void 0 ? void 0 : _k.analyticsName) === null || _l === void 0 ? void 0 : _l.toLowerCase(),
                    basePrice: summary.package.price,
                    totalPrice: (_m = summary.rawtotalprice) === null || _m === void 0 ? void 0 : _m.amount.toString(),
                    totalAccessoriesPrice: (_o = summary.accessories.rawsubtotal) === null || _o === void 0 ? void 0 : _o.amount.toString(),
                    totalAccessoriesNumber: numAcc.toString()
                }
            };
            if (summaryPath && window.zltagger !== undefined) {
                var byo = window.zltagger.getStandardBYOBlock();
                byo.summaryPath = summaryPath;
                finishEvent.byo = byo;
            }
            var success = ZLTagger.push(finishEvent);
            for (var _i = 0, _r = summary.accessories.groups; _i < _r.length; _i++) {
                var group = _r[_i];
                for (var _s = 0, _t = group.items; _s < _t.length; _s++) {
                    var item = _t[_s];
                    var qty = (item.selected || 0) - (item.locked || 0);
                    for (var q = 0; q < qty; q++) {
                        var accTag = {
                            interaction: {
                                "category": "byo accessory summary",
                                "action": window.zltagger.getModelPackageLabel(),
                                "label": (_p = item.analyticsName) === null || _p === void 0 ? void 0 : _p.toLowerCase()
                            },
                            byoAccessory: {
                                accessoryName: (_q = item.analyticsName) === null || _q === void 0 ? void 0 : _q.toLowerCase(),
                                accessoryColor: "",
                                accessoryCategory: group.name.toLowerCase(),
                                accessoryPrice: item.price
                            }
                        };
                        success = success && ZLTagger.push(accTag, true); // spec doesn't have byoModel block on this event for some reason.
                    }
                }
            }
            return success;
        }
        return false;
    };
    ZLTagger.UCXX_takephoto = function () {
        ZLTagger.cloudmine(["BYOTakePhoto"]);
    };
    ZLTagger.UCXX_printsummary = function () {
        ZLTagger.cloudmine(["BYOPrintSummary"]);
    };
    return ZLTagger;
}());
exports.ZLTagger = ZLTagger;
function taggingIsInitialised() {
    return window.zltagger !== undefined;
}
exports.taggingIsInitialised = taggingIsInitialised;
function taggingInit(locale, flow, buildId, modelType, modelName, platformId, packageId, packageName, modelSku, modelYear, summary) {
    window.zltagger = new ZLTagger(locale, flow, buildId, modelType, modelName, platformId, packageId, packageName, modelSku, modelYear, summary);
    window.options_tagger = ZLTagger.UC03_options;
    window.addEventListener("afterprint", ZLTagger.UCXX_printsummary);
    return true;
}
exports.taggingInit = taggingInit;
function taggingUpdateModelInfo(modelSku, packageName) {
    if (window.zltagger !== undefined) {
        window.zltagger.updateModelInfo(modelSku, packageName);
    }
}
exports.taggingUpdateModelInfo = taggingUpdateModelInfo;
function taggingUpdateEnvironment(environment) {
    if (window.zltagger !== undefined) {
        window.zltagger.updateEnvironment(environment);
    }
}
exports.taggingUpdateEnvironment = taggingUpdateEnvironment;
//# sourceMappingURL=tagging.js.map